module.exports = __webpack_public_path__ + "static/media/ow-selector-color.da34a61f.png";